import {
  UpdateSourceRequest,
  UpdateSourceResponse,
} from "@gx/ts-contracts/services/source/api/source_pb";
import { SourceConfiguration } from "@gx/ts-contracts/services/source/resources/source_configuration/source_configuration_pb";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

export enum EditSourceFormActionType {
  SET_SOURCE_RESOURCE = "SET_SOURCE_RESOURCE",
  SET_UPDATE_SOURCE_REQUEST = "SET_UPDATE_SOURCE_REQUEST",
  SET_UPDATE_SOURCE_REQUEST_CONFIGURATION = "SET_UPDATE_SOURCE_REQUEST_CONFIGURATION",
  SET_UPDATE_SOURCE_RESPONSE = "SET_UPDATE_SOURCE_RESPONSE",
  SET_IS_LOADING = "SET_IS_LOADING",
  SET_IS_UPDATE_SOURCE_SUCCEEDED = "SET_IS_UPDATE_SOURCE_SUCCEEDED",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
}

export interface SetSourceResourceAction {
  type: EditSourceFormActionType.SET_SOURCE_RESOURCE;
  payload: SourceResource;
}

export interface SetUpdateSourceRequestAction {
  type: EditSourceFormActionType.SET_UPDATE_SOURCE_REQUEST;
  payload: UpdateSourceRequest;
}

export interface SetEditSourceRequestConfigurationAction {
  type: EditSourceFormActionType.SET_UPDATE_SOURCE_REQUEST_CONFIGURATION;
  payload: SourceConfiguration;
}

export interface SetUpdateSourceResponseAction {
  type: EditSourceFormActionType.SET_UPDATE_SOURCE_RESPONSE;
  payload: UpdateSourceResponse;
}
export interface SetIsLoadingAction {
  type: EditSourceFormActionType.SET_IS_LOADING;
  payload: boolean;
}

export interface SetIsUpdateSourceSucceededAction {
  type: EditSourceFormActionType.SET_IS_UPDATE_SOURCE_SUCCEEDED;
  payload: boolean;
}

export interface SetShouldShowErrorsAction {
  type: EditSourceFormActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export type EditSourceFormAction =
  | SetSourceResourceAction
  | SetUpdateSourceRequestAction
  | SetEditSourceRequestConfigurationAction
  | SetUpdateSourceResponseAction
  | SetIsLoadingAction
  | SetIsUpdateSourceSucceededAction
  | SetShouldShowErrorsAction;
